import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The university lecture structure is all wrong",
  "description": "",
  "published": "2009-10-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-university-lecture-structure-is-all-wrong/swizec/772"],
  "categories": "Artificial intelligence, food for thought, Lisp, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Math_lecture_at_TKK.JPG"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Math_lecture_at_TKK.JPG/300px-Math_lecture_at_TKK.JPG",
              "alt": "A mathematics lecture, apparently about linear...",
              "title": "A mathematics lecture, apparently about linear..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Math_lecture_at_TKK.JPG"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Yesterday I was attending a lecture about `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Artificial_intelligence",
        "title": "Artificial intelligence"
      }}>{`artificial intelligence`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lisp_%28programming_language%29",
        "title": "Lisp (programming language)"
      }}>{`Lisp`}</a>{`.`}</p>
    <p>{`The whole thing was a complete brainfuck, most of the time I was left with eyes glazed over staring at the projection and feeling a little bit butt raped. And yet, I still feel like I've learned a lot and the whole thing was a very worthwhile way of spending time. This is very often the case with outside `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/University",
        "title": "University"
      }}>{`university`}</a>{` lectures, brainfuck to the extreme, yet useful.`}</p>
    <p>{`On the other hand we have university lectures. They are only very rarely a complete brainfuck and when they `}<em parentName="p">{`are`}</em>{` a brain fucking machine, they're so high in the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Stratosphere",
        "title": "Stratosphere"
      }}>{`stratosphere`}</a>{` you can't even begin to hope to start comprehending what the fuck is going on. These are also the kind of lectures you'd be hard pressed to listen to for more than 45 minutes at a time and are all together almost quite useless.`}</p>
    <p>{`So what's the difference?`}</p>
    <p>{`Well university lectures usually have a lot to say and even more time to say it in. They can go at a painfully slow pace, or the lecturer can decide to cram so much stuff in that it would really take almost a lifetime to understand all of it. But this isn't the primary problem.`}</p>
    <p>{`What I think really sucks with university lectures is that there is no Q&A time at the end. Sure professors usually encourage us to ask questions, sometimes they even go so far as to finish with "So are there any questions?" But they do this all wrong. Most of the time they are verbally asking for questions, but not really behaving like they are prepared to answer questions.`}</p>
    <p>{`In a university `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Lecture_hall",
        "title": "Lecture hall"
      }}>{`lecture hall`}</a>{` the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Professor",
        "title": "Professor"
      }}>{`professor`}</a>{` might finish by asking for questions. But they do this a minute before the end, often even after the end when everyone's in a rush to get to the next thing on their schedule. This isn't really a constructive way to conduct a Q&A since people take some time to process what's been said and muster a question; there's also the small case of anxiety about asking something in front of 200 relative strangers. Asking for questions during the lecture also isn't a very good option since people will likely be unwilling to interrupt your reasoning and/or might be afraid you'll answer in the rest of the lecture.`}</p>
    <p>{`I must admit I don't really know the answer to this problem, usually outside university lectures are on a loose schedule and there's easily enough time to ask questions. Yesterday I think we spent a good 20 minutes of the two hours just for Q&A. At uni most lectures have to be put within an hour and the perfectly available 15 minutes are spent on what we call academic fifteen .... perhaps that should be replace by something more useful, I don't know.`}</p>
    <p>{`What do you guys think? Am I completely off my rocker here or could we somehow improve the quality of our classes without delving too much into changing the curriculum?`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/44c0d493-504f-45cf-9559-6f7ce28806a2/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=44c0d493-504f-45cf-9559-6f7ce28806a2",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      